import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import Typography from "@material-ui/core/Typography";
import PollIcon from "@material-ui/icons/Poll";
import IconButton from "@material-ui/core/IconButton";
import PrintIcon from "@material-ui/icons/Print";
import ShareIcon from "@material-ui/icons/Share";
import CircularProgress from "@material-ui/core/CircularProgress";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import ProfitTable from './ProfitTable';
import ImportContactsIcon from '@material-ui/icons/ImportContacts';
import CloudDownloadOutlinedIcon from '@material-ui/icons/CloudDownload';
import ToolTip from "@material-ui/core/Tooltip";
import plLocale from "date-fns/locale/pl";
import DateFnsUtils from '@date-io/date-fns';
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import { Popover, Paper, Dialog, DialogContent } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

import { apiurl } from '../app/prefs.js';

import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
  DatePicker,
} from '@material-ui/pickers';

const VideoIcon = (props) => (
  <svg
    style={{ ...props.style }}
    class="svg-icon"
    width='26px'
    height='26px'
    color='#0b6471'
    viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M725.333333 574.506667l170.666667 113.770666V335.722667l-170.666667 113.770666v125.013334z m0-227.562667l189.653334-126.442667C943.36 201.6 981.333333 221.930667 981.333333 256v512c0 34.069333-37.973333 54.4-66.346666 35.498667L725.333333 677.056v48.106667C725.333333 784.085333 677.504 832 618.752 832H149.248A106.666667 106.666667 0 0 1 42.666667 725.162667V298.837333C42.666667 239.914667 90.496 192 149.248 192h469.504A106.666667 106.666667 0 0 1 725.333333 298.837333v48.106667zM128 298.837333v426.325334A21.333333 21.333333 0 0 0 149.248 746.666667h469.504c11.584 0 21.248-9.685333 21.248-21.504V298.837333A21.333333 21.333333 0 0 0 618.752 277.333333H149.248C137.664 277.333333 128 287.018667 128 298.837333z" fill="#0b6471" /></svg>
);

const PlayIcon = () => (
  <svg width="40px" height="40px" viewBox="-1 0 14 14" id="meteor-icon-kit__solid-play-s" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_iconCarrier"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 1.00154V13.0015C0 13.7788 0.84797 14.259 1.5145 13.859L11.5145 7.859C12.1618 7.4706 12.1618 6.5325 11.5145 6.1441L1.5145 0.14405C0.84797 -0.25586 0 0.22425 0 1.00154z" fill="#758CA3"></path></g></svg>
);

export default function Report022() {
  const [totalData, setTotalData] = React.useState([]);
  const [totalDataLoaded, setTotalDataLoaded] = React.useState(false);
  const [filtersLoaded, setFiltersLoaded] = React.useState(false);
  const [dateList, setDateList] = React.useState([]);
  const [startDate, setStartDate] = React.useState(null);
  const { getAccessTokenSilently, user } = useAuth0();

  const optionsData = [
    { value: 'single', label: 'Jednoetapowe' },
    { value: 'multi', label: <>Wieloetapowe</> },
    { value: 'single_v2', label: <> Jednoetapowe wer. 2</> },
    { value: 'single_v3', label: <> Wieloetapowe wer. 2</> },
    { value: 'multi_v5', label: <> Wieloetapowe wer. 3</> },
    { value: 'single_v6', label: <>Jednoetapowe wer. 3</> },
    { value: 'multi_v7', label: <><sup style={{color: '#FE8E3C', fontWeight: 'bold', marginTop: '-10px'}}>N</sup> Wieloetapowe wer. 4</> },
  ]

  const [toggleFilter, setToggleFilter] = React.useState("single");
  const changeToggleFilter = (event, newOption) => {
    if (newOption && newOption !== toggleFilter) {
      setToggleFilter(newOption);
      loadData(startDate.getFullYear(), startDate.getMonth() + 1, newOption);
    }
  };
  const ToggleFilterButton = () => {
    return (
      optionsData ? <ToggleButtonGroup
        value={toggleFilter}
        exclusive
        size="small"
        onChange={changeToggleFilter}
        aria-label="text alignment"
      >
        {optionsData.map((option) => (
          <ToggleButton
            key={option.value}
            style={{ width: "200px", border: 'none', height: '30px' }}
            value={option.value}
            aria-label="left aligned"
          >
            {option.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
        :
        null
    )
  }

  const loadData = (year, month, option) => {
    setTotalDataLoaded(false);
    const apiUrl = `${apiurl}/allocations/${year}/${month}/${option}`;
    getAccessTokenSilently().then((token) => {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      };
      fetch(apiUrl, requestOptions)
        .then((res) => res.json())
        .then((fetchedData) => {
          if (year) {
            //console.log(fetchedData)
            setTotalData(fetchedData);
            setTotalDataLoaded(true);
          }
        });
    });
  }

  React.useEffect(() => {
    let mounted = true;
    //console.log("Main mounted");
    loadFilters();
    return function cleanup() {
      //console.log("Main unmounted");
      mounted = false;
    };
  }, []);

  const loadFilters = () => {
    setFiltersLoaded(false);
    const apiUrl = `${apiurl}/periodslist`;
    getAccessTokenSilently().then((token) => {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      };
      fetch(apiUrl, requestOptions)
        .then((res) => res.json())
        .then((fetchedData) => {
          let listOfDates = fetchedData.CONTENT_SUMMARY.filter(item => item.version === 1).map(item => { return new Date(`${item.year}-${item.month}-01`) })
          setDateList(listOfDates);
          if (listOfDates && listOfDates.length !== 0) {
            setStartDate(listOfDates[listOfDates.length - 1]);
            loadData(listOfDates[listOfDates.length - 1].getFullYear(), listOfDates[listOfDates.length - 1].getMonth() + 1, toggleFilter);
            setFiltersLoaded(true);
          }
        });
    });
  }

  const [videoListOpen, setVideoListOpen] = React.useState(false);
  const [videoPlayDialogOpen, setVideoPlayDialogOpen] = React.useState(false);
  const [selectedVideo, setSelectedVideo] = React.useState(undefined);

  const handleVideoListClose = () => {
    setVideoListOpen(false)
  };
  const videoData = [
    {
      image: '/manual/reports/Eksport_rozliczen.jpg',
      video: '/manual/reports/Eksport_rozliczen.mp4'
    }
  ];

  const handleVideoSelect = (video) => {
    setSelectedVideo(video);
    setVideoListOpen(false);
    setVideoPlayDialogOpen(true);
  };

  const VideoList = () => {
    return <div>
      {
        videoData.map(
          (v, i) => {
            return <div className="videoListItem" onClick={() => handleVideoSelect(v)}>
              <div style={{ position: 'relative' }}>
                <img src={v.image} alt={'Video nr ' + i} />
                <div style={{
                  position: 'absolute',
                  top: '90px',
                  left: '190px',
                  opacity: '.5',
                  color: 'gray'
                }}>
                  <PlayIcon />
                </div>
              </div>
            </div>
          }
        )
      }
    </div>
  }

  return (
    <div className="App" style={{ position: "relative" }}>
      <div
        style={{
          background: "linear-gradient(to right, #0b6471, #9BC0C5)",
          display: "flex",
          height: "55px",
          width: "100%",
          backgroundColor: "#0b6471",
          color: "white",
          borderRadius: "5px",
          paddingTop: "0px",
          paddingLeft: "0px",
          alignItems: "center",
        }}
      >
        <div style={{ width: "80px", marginTop: "5px" }}>
          <PollIcon
            style={{
              marginLeft: "20px",
              marginRight: "20px",
              fontSize: "42px",
            }}
          />
        </div>
        <div>
          <Typography variant="h5" style={{ color: "white" }}>
            Eksport wyników rozliczeń
          </Typography>
        </div>
      </div>
      <p style={{ height: "5px" }} />
      {totalDataLoaded ? (
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            position: "relative",
            width: "100%",
            alignItems: 'flex-end',
          }}
        >
          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={plLocale}>
            <KeyboardDatePicker
              style={{
                marginRight: "20px",
                width: "200px",
                justifyContent: "left",
              }}
              disableToolbar
              autoOk
              variant="inline"
              minDate={dateList[0]}
              maxDate={dateList[dateList.length - 1]}
              format="yyyy-MM"
              views={["month", "year"]}
              margin="dense"
              id="date-picker-inline"
              placeholder='Wybierz miesiąc'
              value={startDate}
              onChange={date => {
                setStartDate(date);
              }}
              //onAccept={date => loadData(date.getFullYear(), date.getMonth() + 1, toggleFilter)}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
            />
          </MuiPickersUtilsProvider>
          <ToolTip title='Instrukcje video'>
            <div style={{ height: '36px', marginRight: '20px', paddingTop: '5px' }}
              onClick={
                () => {
                  setSelectedVideo(videoData[0]);
                  setVideoPlayDialogOpen(true);
                }
              }>
              <VideoIcon style={{ marginTop: '0px', cursor: 'pointer' }}></VideoIcon>
            </div>
          </ToolTip>
          <ToggleFilterButton />

          {true && <div style={{ position: "absolute", right: "15px" }}>
            <ToolTip title="Pobierz jako plik MS Excel" placement="top-start">
              <IconButton
                onClick={
                  () => {
                    getAccessTokenSilently().then((token) => {
                      document.body.style.cursor = 'wait';
                      const tempapi = (toggleFilter == 'multi_v7') ? 
                      `${apiurl}/allocations/${startDate.getFullYear()}/${startDate.getMonth() + 1}/${toggleFilter}/xls`
                      : `${apiurl}/allocationstoxls/${startDate.getFullYear()}/${startDate.getMonth() + 1}/${toggleFilter}`;
                      fetch(tempapi, {
                        method: 'GET',
                        headers: {
                          'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                          Authorization: "Bearer " + token,
                        },
                      })
                        .then((response) => response.blob())
                        .then((blob) => {
                          // Create blob link to download
                          const url = window.URL.createObjectURL(
                            new Blob([blob]),
                          );
                          const link = document.createElement('a');
                          link.href = url;
                          link.setAttribute(
                            'download',
                            `Rozliczenia.xlsx`,
                          );
                          // Append to html link element page
                          document.body.appendChild(link);
                          // Start download
                          link.click();
                          // Clean up and remove the link
                          link.parentNode.removeChild(link);
                          document.body.style.cursor = 'auto';
                        });
                    });
                  }
                }
              >
                <CloudDownloadOutlinedIcon />
              </IconButton>
            </ToolTip>
          </div>}
        </div>
      ) : (
        <div>Wczytywanie danych</div>
      )}
      <p style={{ height: "5px" }} />

      {totalData ? (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            overflow: "auto",
            transition: "opacity 0.5s",
            opacity: totalDataLoaded ? "1" : "0.2",
          }}
        >
          <div
            id="top chart area"
            style={{
              display: "flex",
              flexWrap: "wrap",
              width: "100%",
              flexDirection: "row",
            }}
          >
            <div
              id="left chart area"
              style={{
                display: "flex",
                flexWrap: "wrap",
                //maxWidth: "840px",
                width: "100%",
                flexDirection: "column",
                flexShrink: 1,
              }}
            >
              <div
                id="top 3 bottom 3 tables area"
                style={{
                  display: "flex",
                  paddingRight: "0px",
                  alignItems: "stretch",
                  flexWrap: "wrap",
                  width: "100%",
                  flexDirection: "row",
                  flexGrow: 1,
                  flexShrink: 1,
                }}
              >
                {totalData.allocations &&
                  <ProfitTable
                    title="ROZLICZENIA KOSZTÓW POMIĘDZY OPK"
                    data={totalData.allocations}
                    dataType="cost"
                    columns={totalData.headers}
                  />
                }
              </div>
            </div>
          </div>
        </div>
      ) : (
        !totalData && (
          <Typography
            style={{
              position: "absolute",
              top: "120%",
              left: "40%",
              color: "#0b6471",
              textJustify: "left"
            }}
            variant="h5"
          >
            Wczytywanie danych
          </Typography>
        )
      )}
      {!totalDataLoaded && (
        <CircularProgress
          style={{
            position: "absolute",
            height: "70px",
            width: "70px",
            top: totalData[0] ? "50%" : "120%",
            left: "50%",
            color: "#0b6471",
            opacity: "0.6",
          }}
        />
      )}

<Popover
        id='videoSelectPopOver'
        open={videoListOpen}
        anchorEl={document.getElementById('video')}
        onClose={handleVideoListClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center"
        }}
      >
        <Paper
          style={{
            padding: "10px",
            width: "450px",
            fontFamily: "roboto",
            display: "flex",
            flexDirection: "column",
            height: 'calc(100vh - 234px)',
          }}
        >

          <div
            style={{
              top: "0px",
              display: "flex",
              width: "100%",
              justifyContent: "right"
            }}
          >

            <CloseIcon style={{ cursor: 'pointer', fontSize: '16px' }} onClick={() => handleVideoListClose()} />

          </div>

          <VideoList />
        </Paper>
      </Popover>

      <Dialog

        maxWidth='90vw'
        open={videoPlayDialogOpen}
        onClose={() => setVideoPlayDialogOpen(false)}
        aria-labelledby="dialog-title"
        aria-describedby="dialog-description"

      >
        <DialogContent style={{ display: 'flex', flexDirection: 'column', margin: '0px', padding: '0px' }}>
          <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '3px 10px 3px 0px' }}>
            <button
              onClick={() => {
                const div = document.getElementById('videoControl');
                if (div.requestFullscreen)
                  div.requestFullscreen();
                else if (div.webkitRequestFullscreen)
                  div.webkitRequestFullscreen();
                else if (div.msRequestFullScreen)
                  div.msRequestFullScreen();
              }
              }
              style={{ backgroundColor: 'white', color: '#0b6471', fontWeight: 'bold', textDecorationLine: 'underline' }}
            >
              Pełen ekran
            </button>
            <button
              onClick={() => setVideoPlayDialogOpen(false)}
              style={{ backgroundColor: 'white', color: '#0b6471', fontWeight: 'bold', textDecorationLine: 'underline' }}
            >
              Zamknij
            </button>
          </div>
          <video id='videoControl' controls autoPlay style={{ width: '80vw' }}>
            <source src={selectedVideo && selectedVideo.video} type="video/mp4" />
            Video control not supported by browser
          </video>

        </DialogContent>
      </Dialog>


    </div>
  );
}
